import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import AdminControlPanel from './components/AdminControlPanel';
import AdminNotPageFormCreator from './components/AdminNotPageFormCreator';
import AdminNotPageInpost from './components/AdminNotPageInpost';
import AdminNotPageShowForm from './components/AdminNotPageShowForm';
import AdminOrderDetails from './components/AdminOrderDetails';
import AdminOrderList from './components/AdminOrderList';
import AdminProductList from './components/AdminProductList';
import AdminSettings from './components/AdminSettings';
import AdminUserList from './components/AdminUserList';
import AdminNotPageFormList from './components/AdminNotPageFormList';
import Footer from './components/Footer';
import NavigationMenu from './components/NavigationMenu';
import NotPageForm from './components/NotPageForm';
import PageAbout from './components/PageAbout';
import PageContact from './components/PageContact';
import PageForgotPassword from './components/PageForgotPassword';
import PageHome from './components/PageHome';
import PageLogin from './components/PageLogin';
import PageProductDetails from './components/PageProductDetails';
import PageProducts from './components/PageProducts';
import PageProfile from './components/PageProfile';
import PageReceipt from './components/PageReceipt';
import PageRegister from './components/PageRegister';
import PageResetPassword from './components/PageResetPassword';
import PageShippingForm from './components/PageShippingForm';
import UserAccountActivation from './components/UserAccountActivation';
import UserOrderDetails from './components/UserOrderDetails';
import UserOrderSummary from './components/UserOrderSummary';
import PagePaymentStatus from './components/PagePaymentStatus';
import AdminInpost from './components/AdminInpost';

import './styles/App.css';

import { UserProvider } from './context/UserContext';
import { CartProvider } from './context/CartContext';

function App() {
	return (
		<UserProvider>
			<CartProvider>
				<Router>
					<div className="App">
						<NavigationMenu />

						<div className="content">
							<Routes>
								<Route path="/" element={<PageHome />} />
								<Route path="/about" element={<PageAbout />} />
								<Route path="/contact" element={<PageContact />} />
								<Route path="/products" element={<PageProducts />} />
								<Route path="/products/:id" element={<PageProductDetails />} />
								<Route path="/login" element={<PageLogin />} />
								<Route path="/register" element={<PageRegister />} />
								<Route path="/profile" element={<PageProfile />} />
								<Route path="/summary" element={<UserOrderSummary />} />
								<Route path="/receipt" element={<PageReceipt />} />
								<Route path="/delivery" element={<PageShippingForm />} />
								<Route path="/form/:id" element={<NotPageForm />} />
								<Route path="/admin/orders/:id" element={<AdminOrderDetails />} />
								<Route path="/form/admin/:id" element={<AdminNotPageFormCreator />} />
								<Route path="/form/admin/show/:id" element={<AdminNotPageShowForm />} />
								<Route path="/form/admin/delivery/:id" element={<AdminNotPageInpost />} />
								<Route path="/delivery/inpost" element={<AdminInpost />} />
								<Route path="/orders/:id" element={<UserOrderDetails />} />
								<Route path="/activate/:token" element={<UserAccountActivation />} />
								<Route path="/forgot-password" element={<PageForgotPassword />} />
								<Route path="/reset-password/:token" element={<PageResetPassword />} />
								<Route path="/payment/status" element={<PagePaymentStatus />} />
								<Route path="/delivery/inpost" element={<AdminInpost />} />
								<Route path="/admin" element={<AdminControlPanel />}>
								    <Route index element={<AdminProductList />} />
								    <Route path="forms" element={<AdminNotPageFormList />} />
								    <Route path="orders" element={<AdminOrderList />} />
								    <Route path="users" element={<AdminUserList />} />
								    <Route path="settings" element={<AdminSettings />} />
								</Route>
								<Route path="*" element={<p>Strona nie istnieje</p>} />
							</Routes>
						</div>
						<Footer />
					</div>
				</Router>
			</CartProvider>
		</UserProvider>
	);
}

export default App;
